export function generateDefaultFilename(name: string | null): string {
  const timestamp = new Date().toISOString().slice(0, 16).replace('T', '_').replace(':', '')
  return name ? `${name} - ${timestamp}.docx` : `Untitled Document - ${timestamp}.docx`
}
